var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 503.02 280.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.68,
    y1: 255.74,
    x2: 114.99,
    y2: 115.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 254.49,
    y1: 56.43,
    x2: 114.99,
    y2: 115.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 394.31,
    y1: 115.12,
    x2: 254.49,
    y2: 56.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 453.29,
    y1: 255.74,
    x2: 394.31,
    y2: 115.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.68,
    y1: 255.74,
    x2: 453.29,
    y2: 255.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 253.69,
    y1: 255.74,
    x2: 24.33,
    y2: 161.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.89,
    y1: 24.33,
    x2: 253.69,
    y2: 255.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 349.35,
    y1: 26.34,
    x2: 253.69,
    y2: 255.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 478.69,
    y1: 160.99,
    x2: 253.69,
    y2: 255.74
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "415.76 115.12 400.11 120.92 394.31 136.57 388.52 120.92 372.86 115.12 388.52 109.33 394.31 93.67 400.11 109.33 415.76 115.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "275.93 56.43 260.28 62.23 254.49 77.88 248.69 62.23 233.04 56.43 248.69 50.64 254.49 34.99 260.28 50.64 275.93 56.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.44 115.12 120.78 120.92 114.99 136.57 109.2 120.92 93.54 115.12 109.2 109.33 114.99 93.67 120.78 109.33 136.44 115.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.78 161.16 30.12 166.95 24.33 182.61 18.54 166.95 2.88 161.16 18.54 155.36 24.33 139.71 30.12 155.36 45.78 161.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "180.33 24.33 164.68 30.12 158.89 45.78 153.09 30.12 137.44 24.33 153.09 18.54 158.89 2.88 164.68 18.54 180.33 24.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "370.8 26.34 355.14 32.13 349.35 47.78 343.55 32.13 327.9 26.34 343.55 20.54 349.35 4.89 355.14 20.54 370.8 26.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "500.14 160.99 484.48 166.78 478.69 182.44 472.9 166.78 457.24 160.99 472.9 155.2 478.69 139.54 484.48 155.2 500.14 160.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.12 255.74 61.47 261.54 55.68 277.19 49.88 261.54 34.23 255.74 49.88 249.95 55.68 234.29 61.47 249.95 77.12 255.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "474.74 255.74 459.09 261.54 453.29 277.19 447.5 261.54 431.85 255.74 447.5 249.95 453.29 234.29 459.09 249.95 474.74 255.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "262.47 235.55 259.74 249.9 274.17 247.67 262.1 255.89 273.88 264.52 259.53 261.79 261.76 276.23 253.55 264.15 244.92 275.93 247.64 261.59 233.21 263.82 245.28 255.6 233.5 246.97 247.85 249.69 245.62 235.26 253.84 247.33 262.47 235.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheSun);
export default __webpack_public_path__ + "static/media/TheSun.de3e96b48d5d1a72111df650f7f48f92.svg";
export { ForwardRef as ReactComponent };